"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const constants_1 = require("../../../constants/constants");
const eventConstants_1 = require("../../../constants/eventConstants");
const typesConstants_1 = require("../../../constants/typesConstants");
const actionsSlice_1 = require("../../../features/actions/actionsSlice");
const useAppDispatch_1 = __importDefault(require("../../../hooks/useAppDispatch"));
const styles_1 = __importDefault(require("../../../styles/styles"));
const themes_1 = __importDefault(require("../../../styles/themes"));
const actionsLoadingComponent_1 = __importDefault(require("../../actionsLoadingComponent/actionsLoadingComponent"));
const button_1 = __importDefault(require("../../button/button"));
const NotesBox = ({ scheduleId, hideNotes }) => {
    const dispatch = useAppDispatch_1.default();
    const [note, setNote] = react_1.useState('');
    const submitNote = async () => {
        const result = await dispatch(actionsSlice_1.customNotes({ scheduleId, notes: note }));
        if (result.meta.requestStatus === constants_1.FULFILLED_RESPONSE_CONSTANT) {
            setNote('');
            hideNotes();
        }
    };
    return (react_1.default.createElement(actionsLoadingComponent_1.default, { actionType: typesConstants_1.CUSTOM_NOTES_ACTION_TYPE },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_paper_1.TextInput, { label: "Customer's notes", placeholder: "Add custom note about the customer", onChangeText: setNote, left: true, style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput, value: note }),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterCenter, styles_1.default.flexOne] },
                react_1.default.createElement(button_1.default, { text: "SUBMIT", icon: free_solid_svg_icons_1.faCheckCircle, onPress: submitNote, fill: true, eventName: eventConstants_1.ADD_NOTES_PRESS })))));
};
exports.default = NotesBox;
